<template>
  <div>
    <div class="head-box">
      <div class="c-flex c_flex_center">
        <h4>周期计划模板</h4>
        <!-- <span class="f-s-14 c-m-l-15">管理周期计划</span> -->
      </div>
      <div class="c-flex">
        <el-input
          placeholder="请输入名称"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button type="primary" @click="doNew" class="c-m-l-10">新建周期计划模板</el-button>
        <!-- <el-button
          type="primary"
          class="c-m-l-10"
          @click="
            osg.doExport(
              {
                beanName: 'planTemplate',
                title: '周期计划模板列表'
              },
              { dynamic: true }
            )
          "
        >
          数据导出
        </el-button> -->
      </div>
    </div>
    <div class="content-box">
      <!-- <div class="content-filter">
        <c-filter></c-filter>
      </div> -->
      <div class="content-table">
        <el-table
          ref="table"
          height="calc(100% - 50px)"
          :data="fpi.data"
          size="mini"
          v-if="fpi.data && fpi.data.length && extFields.length"
          highlight-current-row
        >
          <el-table-column fixed="right" width="220" label="操作">
            <template slot-scope="scope">
              <el-button @click.native.prevent="doEdit(scope.row)" size="mini">编辑</el-button>
              <template v-if="scope.row.state == 0">
                <el-button
                  type="danger"
                  @click.native.prevent="doEnable(scope.row._id)"
                  size="mini"
                >
                  已禁用
                </el-button>
              </template>
              <template v-else>
                <el-button
                  type="success"
                  @click.native.prevent="doDisable(scope.row._id)"
                  size="mini"
                >
                  已启用
                </el-button>
              </template>
              <el-button @click.native.prevent="doRemove(scope.row._id)" size="mini">
                删除
              </el-button>
            </template>
          </el-table-column>
          <el-table-column label="名称" prop="name" width="180px" fixed></el-table-column>
          <el-table-column label="编号" prop="code" width="180px"></el-table-column>
          <el-table-column
            prop="tplStartTime"
            label="模板有效开始时间"
            min-width="150px"
          ></el-table-column>
          <el-table-column
            prop="tplEndTime"
            label="模板有效结束时间"
            min-width="150px"
          ></el-table-column>
          <el-table-column
            prop="repeatTypeCount"
            label="重复类型数量"
            min-width="100px"
          ></el-table-column>
          <el-table-column
            prop="repeatType"
            label="重复类型"
            min-width="120px"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ osg.codelabel('planTimeType', scope.row.repeatType) }}
            </template>
          </el-table-column>
        </el-table>
        <el-table v-else ref="table" height="calc(100% - 50px)" :data="fpi.data"></el-table>
        <el-pagination
          class="pagination"
          size="mini"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      id="planDialog"
      title="周期计划模板信息"
      :visible.sync="openDetail"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="800px"
    >
      <div style="height: 100%; display: flex; flex-direction: column">
        <el-form
          :model="formData"
          ref="formData"
          :rules="rules"
          label-width="160px"
          label-position="left"
          hide-required-asterisk:true
        >
          <el-form-item prop="name" label="模板名称">
            <el-input v-model="formData.name"></el-input>
          </el-form-item>
          <el-form-item prop="code" label="模板编号">
            <el-input v-model="formData.code"></el-input>
          </el-form-item>
          <el-form-item label="按计划创建时间后" prop="timeTypeCount">
            <el-col>
              <template v-if="$util.isShowField(formData, 'timeType', 'timeType', '0')">
                <el-col :span="10">
                  <el-select
                    v-model="formData.timeType"
                    clearable
                    @change="
                      () => {
                        delete formData.timeTypeCount;
                      }
                    "
                  >
                    <el-option
                      v-for="item in options.planTimeType"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-col>
                <el-col class="line" :span="12" :offset="1">创建即刻执行周期计划</el-col>
              </template>
              <template v-else>
                <el-col :span="3" v-if="!$util.isShowField(formData, 'timeType', 'timeType', '0')">
                  <el-input-number
                    type="number"
                    style="width: 100%"
                    :step="1"
                    step-strictly
                    :controls="false"
                    :min="0"
                    v-model="formData.timeTypeCount"
                  ></el-input-number>
                </el-col>
                <el-col :span="10" :offset="1">
                  <el-select v-model="formData.timeType" clearable>
                    <el-option
                      v-for="item in options.planTimeType"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-col>
                <el-col class="line" :span="9" :offset="1">执行周期计划</el-col>
              </template>
            </el-col>
          </el-form-item>
          <el-form-item label="重复周期" prop="repeatTypeCount">
            <template v-if="$util.isShowField(formData, 'repeatType', 'repeatType', '0')">
              <el-select
                v-model="formData.repeatType"
                @change="
                  () => {
                    delete formData.repeatTypeCount;
                    delete formData.repeatTimesLimit;
                  }
                "
                clearable
              >
                <el-option
                  v-for="item in options.planTimeType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </template>
            <template v-else>
              <el-col>
                <el-col class="line" :span="2">每隔</el-col>
                <el-col :span="3">
                  <el-input-number
                    type="number"
                    style="width: 100%"
                    :step="1"
                    step-strictly
                    :controls="false"
                    :min="0"
                    v-model="formData.repeatTypeCount"
                  ></el-input-number>
                </el-col>
                <el-col :span="10" :offset="1">
                  <el-select v-model="formData.repeatType" clearable>
                    <el-option
                      v-for="item in options.planTimeType"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-col>
                <el-col class="line" :span="7" :offset="1">重复一次</el-col>
              </el-col>
            </template>
          </el-form-item>
          <el-form-item
            prop="repeatTimesLimit"
            label="重复次数"
            v-if="!$util.isShowField(formData, 'repeatType', 'repeatType', '0')"
          >
            <el-input-number
              type="number"
              style="width: 100%"
              :step="1"
              step-strictly
              :controls="false"
              :min="0"
              v-model="formData.repeatTimesLimit"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="开始执行周期计划后" prop="repeatTypeCount">
            <template
              v-if="$util.isShowField(formData, 'repeatDeadlineType', 'repeatDeadlineType', '0')"
            >
              <el-select v-model="formData.repeatDeadlineType" clearable>
                <el-option
                  v-for="item in options.planTimeType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </template>
            <template v-else>
              <el-col>
                <el-col :span="3">
                  <el-input-number
                    type="number"
                    style="width: 100%"
                    :step="1"
                    step-strictly
                    :controls="false"
                    :min="0"
                    v-model="formData.repeatDeadlineTypeCount"
                  ></el-input-number>
                </el-col>
                <el-col :span="10" :offset="1">
                  <el-select v-model="formData.repeatDeadlineType" clearable>
                    <el-option
                      v-for="item in options.planTimeType"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-col>
                <el-col class="line" :span="7" :offset="1">停止执行周期计划</el-col>
              </el-col>
            </template>
          </el-form-item>
          <template
            v-if="$util.isShowField(formData, 'repeatDeadlineType', 'repeatDeadlineType', '0')"
          >
            <el-form-item label="截止时间" prop="repeatDeadlineDueTime">
              <el-date-picker
                v-model="formData.repeatDeadlineDueTime"
                :picker-options="pickerOptions"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="请选择截止时间"
              ></el-date-picker>
            </el-form-item>
          </template>
          <el-form-item label="模板有效时间" prop="tplStartTime">
            <el-date-picker
              v-model="formData.tplTime"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="datetimerangeOptions"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="right"
            ></el-date-picker>
          </el-form-item>

          <el-form-item label="选择执行任务" prop="groovyScriptId">
            <el-select filterable clearable v-model="formData.groovyScriptId">
              <el-option
                v-for="item in options.groovyScriptList"
                :key="item._id"
                :label="item.name"
                :value="item._id"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item prop="validScriptContent" label="新增执行脚本">
            <el-input type="textarea" v-model="formData.validScriptContent"></el-input>
          </el-form-item>
          <el-form-item prop="invalidScriptContent" label="删除执行脚本">
            <el-input type="textarea" v-model="formData.invalidScriptContent"></el-input>
          </el-form-item> -->
        </el-form>
      </div>
      <div slot="footer" style="display: flex; justify-content: space-between">
        <el-button @click="doInit">取 消</el-button>
        <el-button type="primary" @click="doSave">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// import areajs from '../../resources/js/area.js';
// import areaList from '../../resources/js/areaList.js';
export default {
  activated() {
    window.$this = this;
  },
  name: 'CyclePlanTemplates',
  data() {
    return {
      name: 'planTemplate',
      fpi: {}, //周期计划的列表数据
      contactFpi: {}, //客户的列表数据
      searchValue: '', //搜索周期计划-文本框
      searchContactValue: '', //搜索客户-文本框
      openDetail: false,
      formData: {},
      extFields: [], //周期计划模块字段
      extFieldsContact: [], //客户模块字段
      extField: {}, //特殊字段类型 如rate值为number类型,checkbox值为数组不能为空
      rules: this.$util.rules,
      options: {
        codecfg_planTimeType: { codeId: 'planTimeType' }, //时间类型
        // codecfg_planRepeatType: { codeId: 'planRepeatType' }, //重复类型
        codecfg_IS: { codeId: 'IS' }, // 是否
        codecfg_planSourceType: { codeId: 'planSourceType' } //创建来源
      },
      //地址级联
      area: {
        options: this.osg.areaList,
        props: {
          checkStrictly: true,
          expandTrigger: 'hover'
        }
      },
      pickerOptions: {
        disabledDate(time) {
          //8.64e7
          return time.getTime() < Date.now() - 8.64e7; //只能选择今天及今天之后
          //return time.getTime() > Date.now() - 8.64e7; //只能选择今天之前，连今天都不能选
          //8.64e6
          //return time.getTime() < Date.now() - 8.64e6; //只能选择今天之后，连今天都不能选
          //return time.getTime() > Date.now() - 8.64e6; //只能选择今天及今天之前
        },
        shortcuts: [
          {
            text: '一周后',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            }
          },
          {
            text: '一个月后',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 30);
              picker.$emit('pick', date);
            }
          },
          {
            text: '三个月后',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 90);
              picker.$emit('pick', date);
            }
          }
        ]
      },
      //时间区间组件
      datetimerangeOptions: {
        disabledDate(time) {
          //8.64e7
          return time.getTime() < Date.now() - 8.64e7; //只能选择今天及今天之后
          //return time.getTime() > Date.now() - 8.64e7; //只能选择今天之前，连今天都不能选
          //8.64e6
          //return time.getTime() < Date.now() - 8.64e6; //只能选择今天之后，连今天都不能选
          //return time.getTime() > Date.now() - 8.64e6; //只能选择今天及今天之前
        },
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const start = new Date();
              const end = new Date();
              end.setTime(end.getTime() + 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const start = new Date();
              const end = new Date();
              end.setTime(end.getTime() + 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const start = new Date();
              const end = new Date();
              end.setTime(end.getTime() + 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }
        ]
      },
      stringList: [
        'timeType',
        'timeTypeCount',
        'repeatType',
        'repeatTypeCount',
        'repeatTimesLimit',
        'repeatDeadlineType',
        'repeatDeadlineTypeCount'
      ], //字段类型要转string的数组
      isEdit: false, //是否编辑
      stepsActive: 0, //步骤索引
      selectedList: [] //被选中的客户列表
    };
  },
  beforeCreate() {
    window.$this = this;
  },
  async mounted() {
    this.doInit();
    //获取客户模块字段
    // await this.getExtFieldsContact();
    this.osg.ajax(
      'biz/extField/query.do',
      {
        colName: 'contacts',
        _all: '1',
        'is:state|integer#and': 1,
        // 'nin:preset|array-integer#and': 1,
        sortField: 'order',
        sortOrder: 'asc'
      },
      res => {
        this.extFields = res.data;
        this.options = this.options || [];
        for (var item of res.data) {
          //解析字段配置
          if (this.$util.isJson(item.frontEndConfig)) {
            item.frontEndConfig = JSON.parse(item.frontEndConfig);
          } else {
            item.frontEndConfig = {};
          }

          if (item.valueOption) {
            this.options['codecfg_' + item.valueOption] = {
              codeId: item.valueOption
            };
          }
          //级联
          if (item.type == 'cascade')
            this.options['cascadeCode_' + item.valueOption] = {
              codeId: item.valueOption
            };
        }
        this.osg.codeoption(() => {
          this.osg.getFpi();
          this.getData(); //获取周期计划
          this.getGroovyScript(); //脚本列表
        });
      },
      { noload: true }
    );
  },
  methods: {
    format(option, value) {
      return this.osg.codelabel(option, value);
    },
    formatArray(option, value) {
      return this.osg.codelabelForArray(option, value);
    },
    formatProvince(row, column, cellValue) {
      return this.osg.areaObj.province_list[cellValue];
    },
    formatCity(row, column, cellValue) {
      return this.osg.areaObj.city_list[cellValue];
    },
    formatDistrict(row, column, cellValue) {
      return this.osg.areaObj.county_list[cellValue];
    },
    formatState(row, column, cellValue) {
      if (cellValue == 0) return '无效';
      else if (cellValue == 1) return '有效';
      else return '未知';
    },
    formatLeadStatus(row, column, cellValue) {
      return this.osg.codelabel('leadStatus', cellValue);
    },
    formatLifecycleStage(row, column, cellValue) {
      return this.osg.codelabel('lifecycleStage', cellValue);
    },
    pageSizeChange(pageSize, fpiName) {
      fpiName = fpiName || 'fpi';
      this[fpiName].rows = pageSize;
      fpiName == 'fpi' ? this.getData() : this.getContact();
    },
    pageChange(currentPage, fpiName) {
      fpiName = fpiName || 'fpi';
      this[fpiName].page = currentPage;
      fpiName == 'fpi' ? this.getData() : this.getContact();
    },
    doInit() {
      this.openDetail = false;
      this.formData = { exts: {} };
      this.stepsActive = 0;
      this.selectedList = [];
      if (this.$refs.formData) this.$refs.formData.resetFields();
      this.$util.renderExtField(this.extFields, this.formData);
    },
    getData() {
      var params = {
        page: this.fpi.page,
        rows: this.fpi.rows,
        'regex:name|string#or': this.searchValue,
        'regex:phone|string#or': this.searchValue,
        'regex:email|string#or': this.searchValue,
        'ne:state|integer#and': -1,
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      //添加过滤器参数
      // $that.getParams(params);
      this.osg.setFpi(params);
      this.osg.ajax('basic/planTemplate/query.do', params, res => {
        this.fpi = res;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    //查询脚本列表
    getGroovyScript() {
      let params = {
        _all: '1',
        'regex:name|string#or': this.formData.groovyScriptId,
        'in:state|array-integer#and': '1',
        'in:type|integer#and': '5',
        sortField: 'workflowDefNodeId,order',
        sortOrder: 'asc'
      };
      this.osg.ajax('groovyScript/query.do', params, res => {
        this.options.groovyScriptList = res.data;
      });
    },
    doNew() {
      this.doInit();
      this.isEdit = false; //更新是否编辑
      //   this.getContact(); //获取客户列表
      this.openDetail = true;
    },
    doEdit(row) {
      row = this.$util.deepCopy(row);
      this.$util.renderExtField(this.extFields, row);
      this.plantoString(row); //字段转字符串
      if (row.tplStartTime && row.tplEndTime) {
        row.tplTime = [row.tplStartTime, row.tplEndTime];
      }
      this.isEdit = true; //表示编辑
      this.formData = row;
      this.openDetail = true;
    },
    plantoString(row) {
      for (let item of this.stringList) {
        if (row[item] !== undefined || row[item] !== null) row[item] = String(row[item]);
      }
    },
    //客户模块的字段
    getExtFieldsContact() {
      this.osg.ajax(
        'biz/extField/query.do',
        {
          colName: 'contacts',
          _all: '1',
          'is:state|integer#and': 1,
          sortField: 'order',
          sortOrder: 'asc'
        },
        res => {
          this.extFieldsContact = res.data;
          console.log(this.extFieldsContact, 'this.extFieldsContact');
          this.options = this.options || [];
          for (var item of res.data) {
            //解析字段配置
            if (this.$util.isJson(item.frontEndConfig)) {
              item.frontEndConfig = JSON.parse(item.frontEndConfig);
            } else {
              item.frontEndConfig = {};
            }
            if (item.valueOption) {
              this.options['codecfg_' + item.valueOption] = {
                codeId: item.valueOption
              };
            }
            //级联
            if (item.type == 'cascade')
              this.options['cascadeCode_' + item.valueOption] = {
                codeId: item.valueOption
              };
          }
        },
        { noload: true }
      );
    },
    //获取客户列表
    getContact() {
      var params = {
        page: this.contactFpi.page,
        rows: this.contactFpi.rows,
        'regex:name|string#or': this.searchContactValue,
        'regex:phone|string#or': this.searchContactValue,
        'regex:email|string#or': this.searchContactValue,
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      this.osg.ajax('basic/contacts/query.do', params, res => {
        this.contactFpi = res;
        this.$nextTick(() => {
          this.$refs.contactTable.doLayout();
          this.$forceUpdate();
        });
      });
    },
    // //周期计划信息-上一步
    // stepsBack() {
    //   if (this.stepsActive-- < 1) this.stepsActive = 0;
    // },
    // //周期计划信息-下一步
    // stepsNext() {
    //   if (this.stepsActive == 0 && !this.selectedList.length) {
    //     this.osg.toast('请选择客户', 'warning');
    //     return;
    //   }
    //   if (this.stepsActive++ >= 1) {
    //     this.doSave();
    //     this.stepsActive = 1;
    //   }
    // },
    doSave() {
      if (this.osg.validate()) {
        this.$util.saveExtField(this.extFields, this.formData);
        if (this.formData.tplTime && this.formData.tplTime.length) {
          this.formData.tplStartTime = this.formData.tplTime[0];
          this.formData.tplEndTime = this.formData.tplTime[1];
          delete this.formData.tplTime;
        }

        this.osg.ajax('basic/planTemplate/upsert.do', this.formData, () => {
          this.doInit();
          this.getData();
          this.osg.toast('保存成功！');
        });
      }
    },
    doEnable(id) {
      this.osg.ajax('basic/planTemplate/enable.do', { id }, () => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doDisable(id) {
      this.osg.ajax('basic/planTemplate/disable.do', { id }, () => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doRemove(id) {
      this.osg.confirm('确定要删除吗？', () => {
        this.osg.ajax('basic/planTemplate/remove.do', { id }, () => {
          this.osg.toast('删除成功');
          this.getData();
        });
      });
    },
    //客户列表选择行
    selectionChange(rows) {
      this.selectedList = rows;
    },
    //客户列表勾选当前行
    currentSelection(rows) {
      if (rows.length > 1) this.$refs.contactTable.toggleRowSelection(rows.shift(), false); //单选
    }
  }
};
</script>
<style>
#planDialog .el-dialog__body {
  height: 80vh;
}
.el-alert--success.is-light {
  background-color: #f0f9eb;
  color: #67c23a;
  opacity: 0.9;
}
</style>
